import { rem } from 'polished';
import styled from 'styled-components/macro';

export const StyledWrapper = styled.main`
  padding: ${rem('40px')} 0;
  width: 100%;
`;
